import { createContext, useContext } from "react";

export interface ComposeToChildPayload {
  child: { id: string; first_name: string; last_name: string };
  classroomId: string;
  classroomName: string;
}

export interface ChatOverlayContextValue {
  isOpen: boolean;
  openChat: () => void;
  closeChat: () => void;
  toggleChat: () => void;
  composeToChildPayload: ComposeToChildPayload | null;
  openComposeToChild: (payload: ComposeToChildPayload) => void;
  clearComposePayload: () => void;
}

export const ChatOverlayContext = createContext<ChatOverlayContextValue | null>(null);

export function useChatOverlay(): ChatOverlayContextValue {
  const context = useContext(ChatOverlayContext);
  if (!context) throw new Error("useChatOverlay must be used within ChatOverlayProvider");
  return context;
}
